<template>
  <v-dialog  persistent v-model="isOpen" v-if="data && data.name" max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Variantes duplicadas: {{ data.name }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="duplicatePricesForm" v-model="form.isValid">
          <v-row>
            <v-col cols="12">
              <strong>La variante que selecciones será la que se quedará en el catálogo</strong>, las demás variantes serán borradas y sus referencias en las ordenes de compra y en las recetas serán actualizadas con la vairante seleccionada.
            </v-col>
            <v-col cols="12">
              <v-data-table
                loading-text="Cargando variantes duplicadas..."
                no-data-text="No se encontraron variantes duplicadas"
                :server-items-length="table.total"
                :loading="table.loading"
                :headers="table.headers"
                :items="table.data"
                :options="table.options"
                :footer-props="{ 'items-per-page-options': [50,100,200] }"
                item-key="variant._id"
                selectable-key="variant._id"
                show-select
                single-select
                v-model="table.selected"
                :selected="table.selected"
                @update:options="updateTable"
                class="elevation-1">
                <template v-slot:item.contentQuantity="{ item }">
                  <span>
                    {{ item.variant.contentQuantity }}
                  </span>
                </template>
                <template v-slot:item.contentUnit="{ item }">
                  {{ findUnit(item.variant.contentUnit) }}
                </template>
                <template v-slot:item.displayQuantity="{ item }">
                  {{ item.variant.displayQuantity }}
                </template>
                <template v-slot:item.displayUnit="{ item }">
                  {{ findUnit(item.variant.displayUnit) }}
                </template>
                <template v-slot:item.status="{ item }">
                  {{ statusProduct(item.variant.status) }}
                </template>
                <template v-slot:item.totalOrders="{ item }">
                  {{ item.ordersTotal }}
                </template>
                <template v-slot:item.totalRecipes="{ item }">
                  {{ item.recipesTotal }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          small
          @click="onCloseDuplicatePrices">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          small
          :disabled="!table.selected.length"
          @click="submit">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'DuplicatePricesDetail',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        isValid: false,
        data: {

        }
      },
      table: {
        title: 'Cargando datos de variantes duplicadas...',
        loading: false,
        headers: [
          { text: 'Cantidad de contenido', value: 'contentQuantity', sortable: false },
          { text: 'Unidad de conteniedo', value: 'contentUnit', sortable: false },
          { text: 'Cantidad de presentación', value: 'displayQuantity', sortable: false },
          { text: 'Unidad de presentación', value: 'displayUnit', sortable: false },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Total de OC', value: 'totalOrders', sortable: false },
          { text: 'Total de recetas', value: 'totalRecipes', sortable: false }
          // { text: 'Acciones', value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 50,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        },
        selected: []
      }
    }
  },
  isOpen: async function (val) {
    if (val) {
      await this.loadDataTable()
    }
  },
  methods: {
    async open () {
      this.isOpen = true
    },
    onCloseDuplicatePrices () {
      this.form.valid = false
      this.form.data = {}
      this.table.selected = []
      this.$emit('close')
      this.isOpen = false
    },
    async submit () {
      const { variant } = cloneDeep(this.table.selected[0])
      const removeId = variant._id
      const dataWithoutVariant = this.table.data.filter(obj => obj.variant._id !== removeId)
      const variants = dataWithoutVariant.map(obj => obj.variant._id)

      this.overlay = true
      this.table.loading = true
      if (this.$refs.duplicatePricesForm.validate()) {
        try {
          await this.$api.post(`/v1/catalog/pricing/${this.provider}/clean-duplicate-prices`, { variantSelected: variant._id, variants })
          this.onCloseDuplicatePrices()
          this.$emit('submit')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        } finally {
          this.table.loading = false
          this.overlay = false
        }
      }
    },
    async loadDataTable () {
      this.table.loading = true
      try {
        this.table.data = this.data.duplicatedVariants
        this.table.total = this.data.duplicatedVariants.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async updateTable (data) {
      this.table.options.page = data.page
      this.table.options.itemsPerPage = data.itemsPerPage
      this.table.options.sortBy = data.sortBy
      this.table.options.sortDesc = data.sortDesc

      const params = {
        limit: this.table.options.itemsPerPage,
        skip: this.table.options.itemsPerPage * (this.table.options.page - 1)
      }

      try {
        await this.loadDataTable(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    findUnit (id) {
      const unit = this.$store.state.units.find(unitId => unitId._id === id)
      return unit.name || '-'
    },
    statusProduct (status) {
      return {
        approved: 'Aprovado',
        'in-review': 'En revisión.',
        published: 'Publicado'
      }[status]
    }
  }
}
</script>
